import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { epinPermissions } from '@/mocks/epin';

export default function EpinPermissions() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="角色权限边界"
          subtitle="每个角色只能在授权范围内操作，原始记录不可覆盖，确保全链路数据的可信与可审计。"
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {epinPermissions.map((item) => (
            <Reveal key={item.role}>
              <div className="h-full flex flex-col p-6 rounded-lg bg-background-50 border border-background-200">
                <div className="flex items-center gap-2.5">
                  <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="font-heading font-bold text-base text-foreground-950">{item.role}</h3>
                </div>
                <p className="mt-3.5 text-sm text-foreground-600 leading-relaxed">{item.rule}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}